import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useIsDesktop } from "@hooks/layout";

import { AccountType, useAccountType } from "@/contexts/AccountTypeContext";

import * as Styled from "../styles";
import { THandleNextStepProp } from "../utils";

export const FindOut: FC<Pick<THandleNextStepProp, "handleLeftChoice">> = ({ handleLeftChoice }) => {
  const isDesktop = useIsDesktop();
  const { accountType } = useAccountType();
  const isSub = accountType === AccountType.SUBSCRIPTION;

  const { t } = useTranslation(isDesktop ? "questionFlow" : "questionFlowMobile");

  const prefix = isSub ? "subscriptionVariant.basicSteps.start" : "basicSteps.start";

  return (
    <Styled.ContentWrapper>
      <Styled.StartText>
        <Styled.Heading style={{ fontSize: "2rem" }}><Trans t={t} i18nKey={`${prefix}.title`} /></Styled.Heading>
        <Styled.Description>{t(`${prefix}.description`)}</Styled.Description>
      </Styled.StartText>
      <Styled.PrimaryButton $fullWidth onClick={() => handleLeftChoice()}>
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#60a3d7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
          <circle cx="12" cy="12" r="10" />
          <polygon points="10 8 16 12 10 16 10 8" fill="#60a3d7" stroke="#60a3d7" />
        </svg>
        {t(`${prefix}.buttonText`)}
      </Styled.PrimaryButton>
    </Styled.ContentWrapper>
  );
};
